var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EChart',{attrs:{"options":_vm.chartData,"card":"","header":_vm.$t('averagePrice'),"tooltip":_vm.$t('headerTooltip'),"loading":_vm.request.getLoading()}})
}
var staticRenderFns = []

export { render, staticRenderFns }